import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  nameTitle: {
    defaultMessage: 'Name',
    id: 'qME1s+',
    description: 'Profile screen: chauffeur info: title',
  },
  birthdayTitle: {
    defaultMessage: 'Date of birth',
    id: 'BGzd2M',
    description: 'Profile screen: chauffeur info',
  },
  genderTitle: {
    defaultMessage: 'Gender',
    id: 'onboarding_gender_title',
    description: 'Gender field title',
  },
  phoneTitle: {
    defaultMessage: 'Phone',
    id: 'emlGDr',
    description: 'Profile screen: chauffeur info',
  },
  emailTitle: {
    defaultMessage: 'Email',
    id: '+nCb+d',
    description: 'Profile screen: chauffeur info',
  },
  usDriverLicenseTitle: {
    defaultMessage: 'TLC Driver License Number',
    id: 'us_tlc_driver_license_number_title',
    description: 'US TLC Driver License number field title',
  },
  frVtcTitle: {
    defaultMessage: 'VTC Number',
    id: 'MpXmtX',
    description: 'Profile screen: chauffeur info',
  },
  gbLicensingAuthorityTitle: {
    defaultMessage: 'Licensing authority',
    id: 'RR6X3y',
    description: 'Profile screen: chauffeur info',
  },
  gbLicenceNumberTitle: {
    defaultMessage: 'Licence number',
    id: 'uK4lBu',
    description: 'Profile screen: chauffeur info',
  },
  gbInsuranceTitle: {
    defaultMessage: 'Insurance number',
    id: 'XC07/C',
    description: 'Profile screen: chauffeur info',
  },
  ruInnTitle: {
    defaultMessage: 'INN',
    id: 'K9H/GO',
    description: 'Profile screen: chauffeur info: for RU',
  },
  addressTitle: {
    defaultMessage: 'Home address',
    id: '4TxXBI',
    description: 'Profile screen: chauffeur info: title',
  },
  title: {
    defaultMessage: 'Chauffeur info',
    id: '90lmj0',
    description: 'Profile screen: subheader',
  },
  editAction: {
    defaultMessage: 'Edit',
    id: 'global_action_edit',
    description: 'Profile screen: button text',
  },
});
